import Big from "big.js";

/**
 * (H) IBBY数量 = (A+B) x [gRatio_IBBY]
 * @param {number} trialAfterCorrection (A)テスト品のトライアル購入数量(補正後)
 * @param {number} repeat （B）購入者購入数量
 * @param {number} gRatio IBBY比率
 */
export const calcIBBY = (trialAfterCorrection: Big, repeat: Big, gRatio: number) => {
	return trialAfterCorrection.add(repeat).mul(gRatio);
};
